import { attr, fk } from 'redux-orm';

import BaseModel from './BaseModel';
import ActionTypes from '../constants/ActionTypes';

export default class extends BaseModel {
  static modelName = 'DampingCoefficient';

  static fields = {
    id: attr(),
    from: attr(),
    to: attr(),
    value: attr(),
    pointSistemId: fk({
      to: 'PointSystem',
      as: 'pointSystem',
      relatedName: 'dampingCoefficients',
    }),
  };

  static reducer({ type, payload }, DampingCoefficient) {
    switch (type) {
      case ActionTypes.SOCKET_RECONNECT_HANDLE:
        DampingCoefficient.all().delete();

        if (payload.dampingCoefficients) {
          payload.dampingCoefficients.forEach((dampingCoefficient) => {
            DampingCoefficient.upsert(dampingCoefficient);
          });
        }

        break;
      case ActionTypes.CORE_INITIALIZE:
        if (payload.dampingCoefficients) {
          payload.dampingCoefficients.forEach((dampingCoefficient) => {
            DampingCoefficient.upsert(dampingCoefficient);
          });
        }

        break;
      case ActionTypes.DAMPING_COEFFICIENT_GET_OR_CREATE__SUCCESS:
      case ActionTypes.DAMPING_COEFFICIENT_CREATE__SUCCESS:
      case ActionTypes.DAMPING_COEFFICIENT_UPDATE__SUCCESS:
        DampingCoefficient.upsert(payload.item);

        break;
      case ActionTypes.DAMPING_COEFFICIENTS_FETCH__SUCCESS: {
        DampingCoefficient.filter({ pointSistemId: payload.pointSystemId }).delete();
        payload.items.forEach((item) => {
          DampingCoefficient.upsert(item);
        });

        break;
      }
      case ActionTypes.DAMPING_COEFFICIENT_DELETE__SUCCESS:
        DampingCoefficient.withId(payload.item.id)?.delete();

        break;
      default:
    }
  }
}

